<div class="relative inline-block">
  <button
    mmscanButton
    type="button"
    variant="ghost"
    severity="secondary"
    size="icon"
    [attr.aria-label]="'nav.notifications.title' | translate"
    (click)="onNotificationClick()"
  >
    <mmscan-icon [icon]="icons.bell" size="sm" />
  </button>
  @if (unreadNotificationsCount() && unreadNotificationsCount() !== '0') {
    <span
      class="pointer-events-none absolute -top-1 -right-1 z-10 flex h-5 min-w-5 items-center justify-center rounded-full bg-danger px-1 text-xs font-medium text-danger-foreground"
      aria-hidden="true"
    >
      {{ unreadNotificationsCount() }}
    </span>
  }
</div>

<mmscan-drawer [(open)]="visible" size="md">
  <ng-template>
    <mmscan-dialog-header>
      <h2 mmscanDialogTitle>{{ 'nav.notifications.title' | translate }}</h2>
    </mmscan-dialog-header>
    <div mmscanDialogContent class="flex flex-col h-full">
      <div class="flex items-center justify-between gap-2 mb-4">
        <div class="flex gap-2">
          @for (tab of severityTabs; track tab) {
            <button
              mmscanButton
              type="button"
              size="sm"
              [variant]="activeSeverityTab() === tab ? 'solid' : 'outline'"
              [severity]="activeSeverityTab() === tab ? 'primary' : 'secondary'"
              [attr.aria-pressed]="activeSeverityTab() === tab"
              (click)="setActiveSeverity(tab)"
            >
              {{ 'nav.notifications.severity.' + tab | translate }}
              @if (getSeverityCount(tab); as count) {
                <span class="rounded-full bg-background/20 px-1.5 text-xs">{{ count }}</span>
              }
            </button>
          }
        </div>
        @if (unreadNotificationsCount() && unreadNotificationsCount() !== '0') {
          <button mmscanButton type="button" size="sm" variant="ghost" severity="secondary" (click)="markAllAsRead()">
            <mmscan-icon [icon]="icons.check" size="sm" />
            {{ 'nav.notifications.markAllAsRead' | translate }}
          </button>
        }
      </div>

      <div class="flex flex-col flex-1 overflow-y-auto">
        @if (notifications().length === 0 && !notificationsLoading()) {
          <div class="notification-empty text-center py-8">
            <mmscan-icon [icon]="icons.inbox" class="mx-auto mb-2 text-4xl" />
            <p>{{ 'nav.notifications.empty' | translate }}</p>
          </div>
        } @else {
          @for (notification of notifications(); track notification.id) {
            <div
              class="notification-row"
              [ngClass]="getSeverityConfig(notification.severity).stripeClass"
              [class.notification-row--unread]="!notification.readAt"
              role="button"
              tabindex="0"
              [attr.aria-label]="getNotificationTitle(notification)"
              (click)="onCardClick(notification)"
              (keydown.enter)="onCardClick(notification)"
              (keydown.space)="onCardClick(notification)"
            >
              <div class="flex items-start gap-2.5">
                <div class="flex flex-col gap-1 min-w-0 flex-1">
                  <div class="flex items-baseline gap-2">
                    <span class="text-sm truncate" [class.font-semibold]="!notification.readAt">
                      {{ getNotificationTitle(notification) }}
                    </span>
                    <span class="notification-meta text-xs shrink-0 ml-auto">
                      {{ notification.createdAt | date: 'short' : undefined : localeId() }}
                    </span>
                  </div>

                  <p class="notification-message text-sm">
                    @if (isExpanded(notification.id)) {
                      {{ getNotificationText(notification) }}
                    } @else {
                      {{ getTruncatedMessage(notification) }}
                    }
                  </p>

                  <div class="notification-meta flex items-center gap-3 text-xs">
                    <span class="notification-severity" [ngClass]="getSeverityConfig(notification.severity).textClass">
                      {{ 'nav.notifications.severity.' + notification.severity.toLowerCase() | translate }}
                    </span>
                    @if (getResourceName(notification.resourceType); as resourceName) {
                      <span>{{ resourceName }}</span>
                    }
                    @if (getNotificationText(notification).length > 50) {
                      <button
                        type="button"
                        class="notification-action"
                        (click)="toggleExpanded(notification.id, $event)"
                      >
                        {{
                          (isExpanded(notification.id) ? 'nav.notifications.showLess' : 'nav.notifications.showMore')
                            | translate
                        }}
                      </button>
                    }
                    @if (!notification.readAt) {
                      <button
                        type="button"
                        class="notification-action notification-action--hover ml-auto"
                        (click)="markAsReadExplicit(notification, $event)"
                      >
                        {{ 'nav.notifications.markAsRead' | translate }}
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        }
        @if (notificationsLoading()) {
          <div class="flex flex-col gap-2 pt-3">
            <mmscan-skeleton class="h-12" />
            <mmscan-skeleton class="h-12" />
            <mmscan-skeleton class="h-12" />
          </div>
        }

        @if (hasMoreNotifications() && !notificationsLoading() && notifications().length > 0) {
          <div class="notification-load-more flex justify-center py-3">
            <button mmscanButton type="button" size="sm" variant="ghost" severity="secondary" (click)="loadMore()">
              {{ 'nav.notifications.loadMore' | translate }}
            </button>
          </div>
        }
      </div>
    </div>
  </ng-template>
</mmscan-drawer>
